function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.03 16.1L2.41 9.72C2.33 9.65-.01 7.51-.01 4.97c0-3.11 1.9-5 5.07-5 1.86 0 3.59 1.46 4.43 2.29.84-.83 2.58-2.29 4.43-2.29 3.17 0 5.07 1.86 5.07 5 0 2.55-2.33 4.68-2.43 4.77L9.95 16.1a.66.66 0 01-.92 0z"
});

var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 19 16.29"
  }, props), _ref);
};

export default SvgHeart;